import container from "./index";
import * as hubs from "../services/hubs";
import { iid_AuthService } from "sensei-authentication";
import { AuthService } from "../services/authService/AuthService";
import { AuthRootStore, iid_authRootStore } from "../services/authService/AuthRootStore";

container.bind<hubs.IHubManager>(hubs.iid_HubManager).toConstantValue(new hubs.HubManager());

//container.bind(hubs.iid_TestHub).toConstantValue(new hubs.TestHub());
container.bind(hubs.iid_FormsHub).toConstantValue(new hubs.FormsHub());

container.bind(iid_AuthService).to(AuthService).inSingletonScope();
container.bind(iid_authRootStore).to(AuthRootStore).inSingletonScope();
